import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const KEY = "gi_theme";
const EVT = "gi-theme";

const apply = (dark) => {
  document.documentElement.classList.toggle("dark", dark);
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", dark ? "#0B111E" : "#F7F9FC");
};

export function useTheme() {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("dark"));
  useEffect(() => {
    const on = () => setDark(document.documentElement.classList.contains("dark"));
    window.addEventListener(EVT, on);
    return () => window.removeEventListener(EVT, on);
  }, []);
  const toggle = () => {
    const next = !document.documentElement.classList.contains("dark");
    apply(next);
    try { localStorage.setItem(KEY, next ? "dark" : "light"); } catch { /* private mode */ }
    window.dispatchEvent(new Event(EVT));
  };
  return { dark, toggle };
}

export const ThemeToggle = ({ testid = "theme-toggle" }) => {
  const { dark, toggle } = useTheme();
  return (
    <button data-testid={testid} onClick={toggle} aria-label={dark ? "Switch to light mode" : "Switch to dark mode"} title={dark ? "Light mode" : "Dark mode"}
      className="w-10 h-10 rounded-xl flex items-center justify-center text-body hover:text-ink hover:bg-subtle transition-colors">
      {dark ? <Sun className="w-[18px] h-[18px]" /> : <Moon className="w-[18px] h-[18px]" />}
    </button>
  );
};
